import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Seo from "../components/Seo";
import { SectionHead, EventCard, EmptyState, Loader } from "../components/Blocks";

export default function Events() {
  const [items, setItems] = useState(null);
  const [type, setType] = useState("all");

  useEffect(() => {
    api.get("/public/events").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (items === null) return <Loader />;
  const types = ["all", ...Array.from(new Set(items.map((e) => e.event_type).filter(Boolean)))];
  const filtered = type === "all" ? items : items.filter((e) => e.event_type === type);

  return (
    <div data-testid="events-page" className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
      <Seo
        title="Événements"
        description="VytaliDays, VytaliNights, activations partenaires, lancements et séances photo de l'écosystème Vytali."
        path="/evenements"
        kind="event"
      />
      <SectionHead as="h1" label="Agenda" title="Événements">
        VytaliDays et VytaliNights créent le moment. VytaliBoots le capte et le préserve.
      </SectionHead>

      <div className="flex flex-wrap gap-3 mb-10" data-testid="events-filters">
        {types.map((tp) => (
          <button key={tp} className="vb-chip" data-active={type === tp} data-testid={`events-filter-${tp}`} onClick={() => setType(tp)}>
            {tp === "all" ? "Tous" : tp}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <EmptyState message="Aucun événement publié." testid="events-empty" />
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10" data-testid="events-grid">
          {filtered.map((e, i) => (
            <EventCard key={e.id} event={e} testid={`event-card-${i}`} />
          ))}
        </div>
      )}
    </div>
  );
}
